/* eslint-disable @typescript-eslint/naming-convention */
var ContentType;
(function (ContentType) {
    ContentType["error"] = "error";
    ContentType["information"] = "information";
})(ContentType || (ContentType = {}));
var ErrorType;
(function (ErrorType) {
    ErrorType["CARRIER_FMR1_ONLY_ERROR"] = "CARRIER_FMR1_ONLY_ERROR";
    ErrorType["CROSS_ASSAY_ORDER"] = "CROSS_ASSAY_ORDER";
    ErrorType["DEPRECATED_TESTS"] = "DEPRECATED_TESTS";
    ErrorType["DIAGNOSTIC_RNA_OTHER_RRS_COMBO_ERROR"] = "DIAGNOSTIC_RNA_OTHER_RRS_COMBO_ERROR";
    ErrorType["EXOME_SECONDARY_FINDINGS_ADD_ON_WITHOUT_EXOME_ERROR"] = "EXOME_SECONDARY_FINDINGS_ADD_ON_WITHOUT_EXOME_ERROR";
    ErrorType["FORBIDDEN_PRODUCT_TYPES_MIX"] = "FORBIDDEN_PRODUCT_TYPES_MIX";
    ErrorType["FRAGILE_X_ONLY_ERROR"] = "FRAGILE_X_ONLY_ERROR";
    ErrorType["LOCATION_VALIDATION_ERROR"] = "LOCATION_VALIDATION_ERROR";
    ErrorType["LOCATION_VALIDATION_ERROR_PCM_RESTRICTED"] = "LOCATION_VALIDATION_ERROR_PCM_RESTRICTED";
    ErrorType["LOCKED_GENE"] = "LOCKED_GENE";
    ErrorType["MISSING_NY_APPROVAL"] = "MISSING_NY_APPROVAL";
    ErrorType["PATIENT_IS_NOT_ALLOWED_TO_ADD_TESTS"] = "PATIENT_IS_NOT_ALLOWED_TO_ADD_TESTS";
    ErrorType["PREVENTIVE_COMBINED_WITH_PREVENTIVE_ERROR"] = "PREVENTIVE_COMBINED_WITH_PREVENTIVE_ERROR";
    ErrorType["RNA_UNSUPPORTED_COUNTRY_ERROR"] = "RNA_UNSUPPORTED_COUNTRY_ERROR";
})(ErrorType || (ErrorType = {}));

export { ContentType, ErrorType };
//# sourceMappingURL=ModalBuilder.models.esm.js.map
